export default __webpack_public_path__ + "static/media/320D.d590956b.jpg";